import { useEffect, useState } from 'react';

const CURRENCY_META = {
  'sol-erda': { label: 'Sol Erda', abbreviation: 'SE' },
  'sol-erda-fragment': { label: 'Sol Erda Fragments', abbreviation: 'frags' },
} as const;

export type HexaCurrency = keyof typeof CURRENCY_META;

/**
 * Inline Sol Erda / Sol Erda Fragment item icon, rendered right after a cost/progress number in
 * place of the old "SE"/"frags" text (vendored by `scripts/fetch-hexa-icons.mjs`'s currency pass).
 * Unlike `HexaTypeIcon` this icon IS the meaning-carrier (there's no adjacent text label), so it
 * keeps a real `alt`/`title` for screen readers and hover, and a 404 falls back to the old text
 * abbreviation rather than rendering nothing.
 */
export function HexaCurrencyIcon({ currency }: { currency: HexaCurrency }) {
  const [failed, setFailed] = useState(false);
  const src = `/hexa-icons/${currency}.png`;
  const meta = CURRENCY_META[currency];

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (failed) {
    return <>{meta.abbreviation}</>;
  }

  return (
    <img
      src={src}
      alt={meta.label}
      title={meta.label}
      loading="lazy"
      width={16}
      height={16}
      className="inline-block size-4 shrink-0 -translate-y-px object-contain align-text-bottom"
      onError={() => setFailed(true)}
    />
  );
}
